export default "__VITE_ASSET__DrlWaHdm__"